// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilePage_container__20EGa","half":"ProfilePage_half__FFveI","avatarContainer":"ProfilePage_avatarContainer__1JMSb","link":"ProfilePage_link__QlvtB"};